import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import { S } from '../utils/styles';
import { formatDate } from '../utils/styles';

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('active');
  const [monthFilter, setMonthFilter] = useState('');

  useEffect(() => {
    const params = new URLSearchParams();
    if (statusFilter) params.set('status', statusFilter);
    if (monthFilter) { const [y,m] = monthFilter.split('-'); params.set('month',m); params.set('year',y); }
    if (search) params.set('search', search);
    api.get(`/orders?${params}`).then(r => setOrders(r.data)).catch(()=>{});
  }, [statusFilter, monthFilter, search]);

  const months = [];
  const now = new Date();
  for (let i=0; i<14; i++) {
    const d = new Date(now.getFullYear(), now.getMonth()-i, 1);
    months.push(`${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}`);
  }

  const totalValue = orders.reduce((s,o) => s+(o.order_value||0), 0);
  const totalPcs = orders.reduce((s,o) => s+(o.total_pcs||0), 0);

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
        <h1 style={{ fontSize:22, fontWeight:600, margin:0 }}>Orders</h1>
        <Link to="/orders/new" style={{ ...S.btnPrimary, textDecoration:'none', display:'inline-block' }}>+ New order</Link>
      </div>
      <div style={{ display:'flex', gap:10, marginBottom:16, alignItems:'center', flexWrap:'wrap' }}>
        <input value={search} onChange={e => setSearch(e.target.value)}
          placeholder="Search PI, customer, PO..." style={{ ...S.input, width:260 }} />
        <div style={{ display:'flex', gap:6 }}>
          {[['active','Active'],['closed','Closed'],['','All']].map(([s,l]) => (
            <button key={s} onClick={() => setStatusFilter(s)}
              style={{ ...S.btnSm, background:statusFilter===s?'#3b82f6':'#f3f4f6', color:statusFilter===s?'#fff':'#374151', padding:'6px 12px' }}>{l}</button>
          ))}
        </div>
        <select value={monthFilter} onChange={e => setMonthFilter(e.target.value)} style={{ ...S.input, width:180, fontSize:12 }}>
          <option value="">All months</option>
          {months.map(m => <option key={m} value={m}>{new Date(m+'-01').toLocaleDateString('en-IN',{month:'long',year:'numeric'})}</option>)}
        </select>
        {monthFilter && <button onClick={() => setMonthFilter('')} style={{ ...S.btnSm, background:'#fef2f2', color:'#ef4444' }}>Clear</button>}
      </div>

      <div style={{ background:'#fff', borderRadius:10, border:'1px solid #e5e7eb', overflow:'hidden' }}>
        <table style={{ width:'100%', borderCollapse:'collapse' }}>
          <thead><tr>
            {['PI Number','Customer PO','Customer','Items','Total pcs','Value','Ship date','Status',''].map(h => <th key={h} style={S.th}>{h}</th>)}
          </tr></thead>
          <tbody>
            {orders.map(o => {
              const pct = o.total_pcs>0 ? Math.round((o.total_shipped/o.total_pcs)*100) : 0;
              const days = o.expected_ship_date ? Math.ceil((new Date(o.expected_ship_date)-new Date())/(1000*60*60*24)) : null;
              return (
                <tr key={o.id} style={{ borderBottom:'1px solid #f3f4f6' }}>
                  <td style={S.td}><span style={{ color:'#3b82f6', fontWeight:600 }}>{o.pi_number}</span></td>
                  <td style={{ ...S.td, color:'#9ca3af' }}>{o.customer_po||'—'}</td>
                  <td style={S.td}>{o.company_name}</td>
                  <td style={S.td}>{o.item_count}</td>
                  <td style={S.td}>{(o.total_pcs||0).toLocaleString()}</td>
                  <td style={{ ...S.td, fontWeight:500 }}>{o.currency} {(o.order_value||0).toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})}</td>
                  <td style={S.td}>
                    <span style={{ fontWeight:600, fontSize:13, color: days!==null && days<0?'#ef4444':days!==null&&days<=7?'#f97316':'#374151' }}>
                      {formatDate(o.expected_ship_date)}
                    </span>
                  </td>
                  <td style={S.td}>
                    <span style={{ background:o.status==='closed'?'#f0fdf4':pct>0?'#fffbeb':'#eff6ff', color:o.status==='closed'?'#10b981':pct>0?'#f59e0b':'#3b82f6', padding:'3px 8px', borderRadius:20, fontSize:11, fontWeight:500 }}>
                      {o.status==='closed'?'Closed':pct>0?`${pct}% shipped`:'Active'}
                    </span>
                  </td>
                  <td style={S.td}><Link to={`/orders/${o.id}`} style={{ color:'#3b82f6', fontSize:12, textDecoration:'none' }}>View →</Link></td>
                </tr>
              );
            })}
            {orders.length === 0 && (
              <tr><td colSpan={9} style={{ textAlign:'center', padding:32, color:'#9ca3af' }}>
                No orders found. <Link to="/orders/new" style={{ color:'#3b82f6' }}>Create first order →</Link>
              </td></tr>
            )}
            {orders.length > 0 && (
              <tr style={{ background:'#f9fafb', borderTop:'2px solid #e5e7eb' }}>
                <td colSpan={4} style={{ ...S.td, fontWeight:700, fontSize:13 }}>Total ({orders.length} orders)</td>
                <td style={{ ...S.td, fontWeight:700 }}>{totalPcs.toLocaleString()}</td>
                <td style={{ ...S.td, fontWeight:700, color:'#3b82f6' }}>USD {totalValue.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})}</td>
                <td colSpan={3}></td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div style={{ marginTop:8, fontSize:12, color:'#9ca3af' }}>{orders.length} order{orders.length!==1?'s':''} shown</div>
    </div>
  );
}
